import React from 'react';
import { Content, Title, Wrapper } from './Theme';
export const PreviewTemplate = ({selectedTemplate}) => {
    const createMarkup = () => {
        return { __html: selectedTemplate?.htmlContent };
      };
    
    return (
        <Wrapper>
            <Title>Select Template</Title>
            <span>Preview Template</span> <br/>
            <Content>
            <div dangerouslySetInnerHTML={createMarkup()} /> 
            </Content>
            
        </Wrapper>
    );
};

